// LazyLoader
// 0.4.1
// 2020-09-30
// Felix Kiesewetter <info@felixkiesewetter.de>
export default class LazyLoader
{

    constructor (options)
    {
        this.settings = this.setSettings(options);
        this.elements = this.getElements();
        this.debug(this.settings)
        this.debug(this.elements);
        this.init();
    }

    init ()
    {
        try {
            const options = {
                root: this.settings.root || null,
                rootMargin: '0px 0px 0px 0px',
                threshold: .1
            };
            this.intersectionObserver = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.intersectionRatio > 0) {
                        const element = entry.target;
                        if (this.elements.indexOf(element) >= 0) {
                            this.load(element);
                        }
                        else {
                            for (const i in this.elements) {
                                if (element.contains(this.elements[i])) {
                                    this.load(this.elements[i]);
                                }
                            }
                        }
                        this.debug(element);
                        this.intersectionObserver.unobserve(element);
                    }
                });
            }, options);
            this.elements.forEach(element => {
                let closest = false;
                if (false !== this.settings.observeClosest) {
                    closest = element.closest(this.settings.observeClosest);
                }
                this.intersectionObserver.observe(closest ? closest : element);
            });
        }
        catch (error) {
            console.error(error);
        }
    }

    load(element)
    {
        setTimeout(() => {
            const attribute = element.lazyLoaderAttribute;
            if (attribute === 'style') {
                const styles = element.getAttribute(`data-${attribute}`).split(';');
                for (const style of styles) {
                    const property = style.split(':')[0].trim();
                    const value = style.split(':')[1].trim();
                    this.debug({property, value});
                    element.style[property] = value;
                }
            }
            else {
                element.setAttribute(attribute, element.getAttribute(`data-${attribute}`));
            }
            element.removeAttribute(`data-${attribute}`);
            this.debug(`Replacing attribute data-${attribute}`);
            if (this.settings.removeStyles.length) {
                const loadElement = document.createElement('img');
                loadElement.src = `${element.src}?no_cache=${new Date().getTime()}`;
                loadElement.addEventListener('load', () => {
                    for (const style of this.settings.removeStyles) {
                        if (element.style[style].length) {
                            element.style[style] = '';
                        }
                    }
                });
            }
        }, this.settings.delay);
    }

    getElements ()
    {
        let elements = [];
        for (const element of document.querySelectorAll(this.settings.observe)) {
            let observe = false;
            for (const attribute of this.settings.attributes) {
                observe = element.hasAttribute(`data-${attribute}`);
                if (observe) {
                    element.lazyLoaderAttribute = attribute;
                    break;
                }
            }
            if (observe) {
                elements.push(element);
            }
        }
        return elements;
    }

    setSettings (options)
    {
        const defaultSettings = {
            observe: 'img',
            observeClosest: false, // Or selector
            attributes: ['src', 'srcset', 'style', 'url'],
            delay: 0,
            removeStyles: ['filter', 'transform'],
            root: null
        };
        return Object.assign({}, defaultSettings, options);
    }

    debug (d)
    {
        if (this.settings.debug) {
            console.log(d);
        }
    }

}